var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoggedIn && _vm.prices)?_c('price',{attrs:{"price":_vm.prices,"is-product-on-discount":_vm.isProductOnDiscount}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }